module.exports = __webpack_public_path__ + "static/media/goodwin.4cb341ed.jpg";